/** Aligné sur core/modules/handoff — copie locale pour build Docker (sans dépendre de @itaas/core). */

const HANDOFF_MAX_AGE_MS = 5 * 60_000;

export interface AdminHandoffPayload {
  session: { tokens: { accessToken: string } };
  targetPath?: string;
  issuedAt: number;
}

export function parseHandoffPayload(hash: string): AdminHandoffPayload | null {
  const raw = hash.replace(/^#/, "");
  const match = raw.match(/(?:^|&)payload=([^&]+)/);
  if (!match) return null;

  try {
    const b64 = decodeURIComponent(match[1].replace(/\+/g, "%2B"));
    const json = decodeURIComponent(atob(b64));
    const payload = JSON.parse(json) as AdminHandoffPayload;
    if (!payload.session?.tokens?.accessToken) return null;
    if (Date.now() - payload.issuedAt > HANDOFF_MAX_AGE_MS) return null;
    return payload;
  } catch {
    return null;
  }
}
